var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('pp-formatted-number',_vm._b({attrs:{"value":_vm.value}},'pp-formatted-number',_vm.$attrs,false)),_c('span',{domProps:{"textContent":_vm._s((" " + (_vm.token.symbol)))}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }